import { render, staticRenderFns } from "./show-description.vue?vue&type=template&id=3305de5b&scoped=true&"
import script from "./show-description.vue?vue&type=script&lang=js&"
export * from "./show-description.vue?vue&type=script&lang=js&"
import style0 from "./show-description.vue?vue&type=style&index=0&id=3305de5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3305de5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3305de5b')) {
      api.createRecord('3305de5b', component.options)
    } else {
      api.reload('3305de5b', component.options)
    }
    module.hot.accept("./show-description.vue?vue&type=template&id=3305de5b&scoped=true&", function () {
      api.rerender('3305de5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculation-sheets/calculation-sheet/additions/show-description.vue"
export default component.exports